import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

class DownloadCertIcon extends React.PureComponent {
  render() {
    return (
      <SvgIcon {...this.props}>
        <g id="sprint-04-icons" transform="translate(-97.000000, -474.000000)">
          <g id="download-certificate" transform="translate(97.000000, 477.000000)">
            <path d="M5.91,16.11 L1.4,16.11 L1.4,1.18 L7.4,1.18 L7.4,6.05 L12.28,6.05 L12.28,9.18 L13.28,9.18 L13.28,5.18 L8.1,0.18 L0.36,0.18 L0.36,17.18 L5.91,17.18 L5.91,16.11 Z M8.47,1.86 L11.68,5 L8.47,5 L8.47,1.86 Z" id="Shape"></path>
            <path d="M13.27,16.19 C14.4410092,15.1755698 14.7665805,13.4919629 14.0581865,12.1140988 C13.3497926,10.7362348 11.7911079,10.0213704 10.2847139,10.3834594 C8.77831992,10.7455484 7.714799,12.0907072 7.71,13.64 C7.7121465,14.6193637 8.13898262,15.5496476 8.88,16.19 L7.26,19 L8.83,18.55 L9.28,20.12 L11,17 L11.24,17 L12.91,20.15 L13.36,18.58 L14.93,19.03 L13.27,16.19 Z M11.08,15.19 C10.2239586,15.19 9.53,14.4960414 9.53,13.64 C9.53,12.7839586 10.2239586,12.09 11.08,12.09 C11.9360414,12.09 12.63,12.7839586 12.63,13.64 C12.6326835,14.0519024 12.4702423,14.447712 12.1789771,14.7389771 C11.887712,15.0302423 11.4919024,15.1926835 11.08,15.19 Z" id="Shape"></path>
          </g>
        </g>
      </SvgIcon>
    )
  }
}

export default DownloadCertIcon



// WEBPACK FOOTER //
// ./src/js/components/Mui/DownloadCertIcon.js